<script setup>
import '@campact/camper/core/CmprRadioControl.css';
import { dispatchCmprRadioChange } from '@cta/frontend/javascripts/piwik_web_analytics';

const model = defineModel(); // eslint-disable-line vue/require-prop-types
</script>

<template>
  <input
    v-model="model"
    class="cmpr-radio-control__input"
    type="radio"
    @change="dispatchCmprRadioChange($event, model)"
  >
</template>
